import * as React from "react";

function SvgDelivery(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.13 7c0-1.21-.99-2.2-2.2-2.2h-3.3V7h3.3v2.915L14.102 14.7H10.23V9.2h-4.4a4.399 4.399 0 00-4.4 4.4v3.3h2.2c0 1.826 1.474 3.3 3.3 3.3 1.826 0 3.3-1.474 3.3-3.3h4.928l4.972-6.215V7zm-16.5 7.7v-1.1c0-1.21.99-2.2 2.2-2.2h2.2v3.3h-4.4zm3.3 3.3c-.605 0-1.1-.495-1.1-1.1h2.2c0 .605-.495 1.1-1.1 1.1z"
        fill="currentColor"
      />
      <path
        d="M10.23 5.9h-5.5v2.2h5.5V5.9zM20.13 13.6a3.296 3.296 0 00-3.3 3.3c0 1.826 1.474 3.3 3.3 3.3 1.826 0 3.3-1.474 3.3-3.3 0-1.826-1.474-3.3-3.3-3.3zm0 4.4c-.605 0-1.1-.495-1.1-1.1 0-.605.495-1.1 1.1-1.1.605 0 1.1.495 1.1 1.1 0 .605-.495 1.1-1.1 1.1z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgDelivery;
